import Button from '@mui/material/Button'
import Snackbar from '@mui/material/Snackbar'
import { FC, ReactNode } from 'react'
import { To, useNavigate } from 'react-router-dom'

type Props = {
    open: boolean
    message: ReactNode
    isError: boolean
    onClose: VoidFunction
    action?: To
}

export const Notistack: FC<Props> = ({ open, message, isError, onClose, action }) => {
    const navigate = useNavigate()

    const actionButton = action ? (
        <>
            <Button
                color="secondary"
                size="small"
                variant="text"
                sx={{ mr: 2 }}
                onClick={() => navigate(action)}>
                Перейти
            </Button>
        </>
    ) : (
        ''
    )

    return (
        <Snackbar
            className={isError ? 'snackbar-error' : 'snackbar-success'}
            open={open}
            autoHideDuration={5000}
            onClose={onClose}
            message={message}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            action={actionButton}
        />
    )
}
